import { render } from "./App.vue?vue&type=template&id=40b94298"
const script = {}

import "./App.vue?vue&type=style&index=0&id=40b94298&lang=scss"

import exportComponent from "D:\\chenshengnan\\Work\\摩托车\\摩托车要求框架\\提交版\\bicose-customer-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__